import "react-toastify/dist/ReactToastify.css";
import AttributeBars from "../../Dashboard/Component/CompAttributes/CompAttributes";
import { transformDataForMultibarChart } from "../../../utils/helpers";
import { useContext } from "react";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";

export default function AttributesOverview({category, isCategoryOverview=false}) {
    const discoveryCtx = useContext(DiscoveryContext);
    let selectedLLM = discoveryCtx.state.selectedLLM;
    const selectedPersona = discoveryCtx.state.selectedPersona;
    const primaryMarket = discoveryCtx.markets[0];
    const selectedCategory = isCategoryOverview ? category : discoveryCtx.state.selectedCategory;
    let attributeRef = discoveryCtx.positive_negative_attributes?.[selectedLLM]?.[selectedCategory]?.[primaryMarket]?.[selectedPersona];
        
    let positiveAttributes = {};
    let negativesAttributes = {};
    const id = "Attributes_Overview";
    let uniqueKey = `${tab.competitiveOverview}_${id}_${selectedLLM}_${selectedCategory}_${selectedPersona}`;
    const { checked } = useIsSelectedSection({ id, uniqueKey });

    // Check if attributeRef is an array (multiple competitors) or object (single brand)
    if (Array.isArray(attributeRef)) {
        // Handle array case: multiple competitors
        if (attributeRef.length > 0) {
            attributeRef.forEach((competitor) => {
                if (competitor?.positives?.length > 0) {
                    positiveAttributes[competitor.name] = competitor.positives.reduce((a, b) => {
                        return { ...a, [b.name]: b.value };
                    }, {});
                }
                
                if (competitor?.negatives?.length > 0) {
                    negativesAttributes[competitor.name] = competitor.negatives.reduce((a, b) => {
                        return { ...a, [b.name]: b.value };
                    }, {});
                }
            });
        }
    } else if (attributeRef && typeof attributeRef === 'object') {
        // Handle object case: single brand with positives/negatives directly
        if (attributeRef?.positives?.length > 0) {
            positiveAttributes[attributeRef.name] = attributeRef.positives.reduce((a, b) => {
                return { ...a, [b.name]: b.value };
            }, {});
        }
        
        if (attributeRef?.negatives?.length > 0) {
            negativesAttributes[attributeRef.name] = attributeRef.negatives.reduce((a, b) => {
                return { ...a, [b.name]: b.value };
            }, {});
        }
    }

    let positiveAttBarChartData = transformDataForMultibarChart(positiveAttributes, true);
    let negativeAttBarChartData = transformDataForMultibarChart(negativesAttributes, true);

    return (
        <>
            <div className="Heading-checkbox">
                {!isCategoryOverview && <h5>Positive and Negative Attributes</h5>}
                
                {discoveryCtx.state.showReportCheckbox && !isCategoryOverview && (
                    <Checkbox
                        checked={checked}
                        onChange={() => {
                            discoveryCtx?.clickComponentCheckbox({
                                uniqueKey,
                                filter: {
                                    id: id,
                                    title: "Positive and Negative Attributes",
                                    tab: tab.competitiveOverview,
                                    uniqueKey
                                },
                                checked,
                                id,
                            });
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                    />
                )}
            </div>
            {!isCategoryOverview && <hr />}
            <AttributeBars
                negativeAttributes={negativeAttBarChartData}
                positiveAttributes={positiveAttBarChartData}
            />
        </>
    );
}



